import { Box, Flex, Image, Link, useBreakpointValue } from '@chakra-ui/react';

import { SmallLogo } from '../../../assets/Images';
import { LDFlags } from '../../../constants/flags';
import { MKT_HOME } from '../../../constants/urls';
import { Car, Maybe } from '../../../gql/generated/graphql';
import { useFlag } from '../../../hooks';
import AuthMenu from '../../auth/components/AuthMenu';
import Notifications from '../notifications/Notifications';
import MobileHeaderMenu from './MobileHeaderMenu';
import PillDealSwitcher from './PillDealSwitcher';
import PlatformChat from './marketplace/live/conversation/PlatformChat';

type Props = {
  inFlow: boolean;
  car: Maybe<Car>;
  marketplaceDealId?: string;
};

const DashboardHeader = ({ inFlow, car, marketplaceDealId }: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const passwordlessDashboardAccessEnabled = useFlag(LDFlags.PASSWORDLESS_DASHBOARD_ACCESS);

  return (
    <Box px={4} bgColor="grayLightest" overflow="hidden">
      <Flex alignItems="center" maxH="60px" maxW="container.xl" mx="auto">
        <Link href={MKT_HOME} zIndex={50} mr={{ base: -7, md: 0 }}>
          <Box
            position="relative"
            bgColor={{ base: 'grayLightest', md: 'white' }}
            borderRightRadius="full"
            px={2}
            py={3}
            _before={{
              content: '""',
              display: { base: 'none', md: 'block' },
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: '50%',
              width: '100vw',
              bgColor: 'white',
              zIndex: -1,
            }}
          >
            <Image src={SmallLogo} alt="Lease End Logo" minW="40px" h="40px" w="auto" />
          </Box>
        </Link>

        <Flex alignSelf="stretch" flex={{ base: 1, md: '0 1 auto' }} minW={{ base: 0, md: 'auto' }}>
          <PillDealSwitcher inFlow={inFlow} car={car} />
        </Flex>

        <Flex justifyContent="flex-end" alignItems="center" ml="auto" w={{ md: '180px' }}>
          {marketplaceDealId != null && <PlatformChat dealId={marketplaceDealId} />}
          {isMobile ? (
            <MobileHeaderMenu />
          ) : (
            <>
              {passwordlessDashboardAccessEnabled && <Notifications />}
              <AuthMenu color="taupeGray" />
            </>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default DashboardHeader;
